import { inject } from 'mobx-react';
import * as React from 'react';

import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { MultiItemStore } from 'src/common/stores/multi-item-store';

import { ChangeSearchForm } from './internals/change-search-form';
import { CollapsibleSearchForm } from './internals/collapsible-search-form';
import { SharedUiUniversalSearchFormWrapper } from '../../common/universal-search-form/universal-search-form-wrapper';

interface PlaybackProps {
  multiItem?: MultiItemStore;
}

export const Playback: React.FC<PlaybackProps> = inject('multiItem')(({ multiItem }) => {
  const isPageMultiItem = multiItem?.isPackageShoppingPath();

  return isPageMultiItem ? (
    <Viewport>
      <ViewSmall>
        <CollapsibleSearchForm />
      </ViewSmall>
      <ViewMedium>
        <ChangeSearchForm />
      </ViewMedium>
    </Viewport>
  ) : (
    <SharedUiUniversalSearchFormWrapper />
  );
});
